import { render, staticRenderFns } from "./OtherUpdateAction.vue?vue&type=template&id=1681195d&scoped=true"
import script from "./OtherUpdateAction.vue?vue&type=script&lang=js"
export * from "./OtherUpdateAction.vue?vue&type=script&lang=js"
import style0 from "./OtherUpdateAction.vue?vue&type=style&index=0&id=1681195d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1681195d",
  null
  
)

export default component.exports